"use client";

import { useLinkStatus } from "next/link";

import Icon from "@/components/atoms/Icon";
import { cn } from "@/helpers/className";

interface LinkPendingIndicatorProps {
  className?: string;
}

export const CardLinkNavigationIndicator = ({
  className,
}: LinkPendingIndicatorProps) => {
  const { pending } = useLinkStatus();

  if (!pending) {
    return null;
  }

  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 z-20 flex items-center justify-center bg-white/75",
        className,
      )}
    >
      <Icon name="loader" className="h-8 w-8 animate-spin text-yellow-600" />
      <span className="sr-only">Loading</span>
    </div>
  );
};

export default CardLinkNavigationIndicator;
